<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal-bg" @click="close"></div>
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        v-loading="loading"
      >
        <header class="modal-header">
          <slot name="header">
            <h6>
              Notes <span>({{ data.name }})</span>
            </h6>
            <button
              type="button"
              class="modal-btn-close"
              @click="close"
              aria-label="Close modal"
            >
              <img src="@/assets/images/icons/icon-close.svg" alt="Close" />
            </button>
          </slot>
        </header>
        <section class="modal-body" v-if="!loading">
          <div class="modal-body-container border-none">
            <div class="status-response" v-if="formData.response">
              <div :class="formData.isSuccess ? 'is-success' : 'is-error'">
                <img
                  v-if="formData.isSuccess"
                  src="@/assets/images/received.svg"
                  alt="success"
                />
                <img
                  v-else
                  src="@/assets/images/icon-value-removed.svg"
                  alt="error"
                />
                {{ formData.message }}
              </div>
            </div>
            <div class="note-list">
              <div
                class="modal-alert modal-alert_advice text-center"
                v-if="notes.length === 0"
              >
                No notes yet. Start something great!
              </div>
              <ul v-else>
                <li v-for="(note, index) in notes" :key="index">
                  <img :src="note.agent.avatar" alt="" />
                  <div class="note-card">
                    <div class="note-header">
                      <div>{{ note.agent.fullName }}</div>
                      <div>{{ note.createdAt }}</div>
                    </div>
                    <div class="note-body">
                      <!-- Send Email Note  -->
                      <div v-if="note.type === 'email'">
                        <span>
                          Email Sent From
                          <b>{{ note.changeset.from }}</b>
                          to <b>{{ note.changeset.to }}</b
                          >.
                        </span>
                        <div class="note-files">
                          <div class="note-file p-1">
                            <span v-html="note.message"></span>
                          </div>
                        </div>
                      </div>

                      <!-- Send SMS Note  -->
                      <div v-if="note.type === 'sms'">
                        <span>
                          SMS Sent From
                          <b>{{ note.changeset.from }}</b>
                          to <b>{{ note.changeset.to }}</b
                          >.
                        </span>
                        <div class="note-files">
                          <div class="note-file p-1">
                            <span v-html="note.message"></span>
                          </div>
                        </div>
                      </div>

                      <!-- Manual Note  -->
                      <div v-if="note.type === 'note'">
                        <span>{{ note.message }}</span>
                        <div class="note-files">
                          <div
                            class="note-file"
                            v-for="(img, index) in note.files"
                            :key="index"
                          >
                            <img
                              src="@/assets/images/icon-attachment.svg"
                              alt=""
                            />
                            <span>{{ img.name }}</span>
                            <img
                              src="@/assets/images/icon-download.svg"
                              alt=""
                              @click="
                                downloadNoteFile(
                                  note.uuid,
                                  img.filename,
                                  img.name
                                )
                              "
                            />
                          </div>
                        </div>
                      </div>

                      <!-- update Note  -->
                      <div v-if="note.type === 'update_note'">
                        <div class="d-flex" v-if="note.changeset">
                          <div class="w-100 note-body">
                            <span class="assigned-lead">Lead has been updated:</span>
                            <div class="app-updated d-flex align-items-center" >
                              <div class="px-3">{{ note.changeset.property }}</div>
                              <div class="px-3">
                                <img alt="" class="px-1 note-img" src="@/assets/images/icons/icon-value-removed.svg">
                                <span class="value text-muted">{{ note.changeset.from }}</span>
                              </div>
                              <div class="px-3">
                                <img alt="" class="px-1 note-img" src="@/assets/images/icons/icon-value-removed-icon-value-added.svg">
                                <span class="value">{{ note.changeset.to }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <footer class="modal-footer">
          <textarea
            class="notes"
            name="notes"
            id="notes"
            v-model="fields.note"
            cols="30"
            rows="10"
            placeholder="Write a note"
          ></textarea>
          <div class="d-flex align-items-center justify-content-between w-100">
            <input
              type="file"
              ref="file"
              @change="processFiles"
              multiple
              style="display: none"
            />
            <div class="selected-files">
              <button @click="$refs.file.click()" class="btn btn-controls">
                <svg width="25" height="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.703 8.414l-4.596 4.596a1.5 1.5 0 102.121 2.121l3.89-3.889 2.121-2.12a3.001 3.001 0 00-4.243-4.244l-6.718 6.718a4.5 4.5 0 006.364 6.364l5.304-5.304"
                    stroke="#000"
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <span v-if="fields.files.length > 0">
                Selected: {{ fields.files.length }} file(s)
              </span>
            </div>
            <button
              class="btn bg-blue"
              :class="fields.note.length === 0 ? 'disabled' : ''"
              @click="addNote"
              :disabled="fields.note.length === 0"
            >
              <span v-if="formData.loading">Loading ...</span>
              <span v-else>Add notes</span>
            </button>
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Note',
  props: {
    data: { uuid: String, name: String }
  },
  data() {
    return {
      loading: true,
      notes: [],
      fields: {
        note: '',
        files: []
      },
      formData: {
        message: '',
        response: false,
        isSuccess: false,
        loading: false
      }
    }
  },
  methods: {
    loadNote() {
      this.loading = true
      this.notes = []
      this.$http
        .get(`/api/v1/leads/${this.data.uuid}/notes`)
        .then((res) => {
          if (!Array.isArray(res.data.notes)) {
            this.notes.push(res.data.notes)
          } else {
            this.notes = res.data.notes
          }
        })
        .catch((e) => {
          this.pushAlert(this.ALERT_TYPE_ERROR, e.response.statusText)
          this.formData.response = true
          this.formData.message = e.response.statusText
        })
        .finally(() => {
          this.loading = false
        })
    },
    processFiles() {
      this.fields.files = this.$refs.file.files
    },
    addNote() {
      this.formData.loading = true
      let formData = new FormData()
      formData.set('message', this.fields.note)
      for (let i = 0; i < this.fields.files.length; i++) {
        let file = this.fields.files[i]
        formData.append('files[' + i + ']', file)
      }
      formData.append('files', this.fields.files)
      this.$http
        .post('/api/v1/leads/' + this.data.uuid + '/notes/new', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          this.notes.push(res.data.note)
          this.fields.note = ''
          this.fields.files = []
          this.formData.message = 'New Note has been successfully created!'
          this.pushAlert(this.ALERT_TYPE_SUCCESS, 'New Note has been successfully created!')
        })
        .catch((e) => {
          this.pushAlert(this.ALERT_TYPE_ERROR, e.response.statusText)
        })
        .finally(() => {
          this.formData.loading = false
        })
    },
    downloadNoteFile(noteUuid, filename, name) {
      this.$http
        .get(
          `/api/v1/leads/${this.data.uuid}/notes/${noteUuid}/${filename}/${name}`,
          {
            responseType: 'blob'
          }
        )
        .then((res) => {
          var fileURL = window.URL.createObjectURL(new Blob([res.data]))
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', name)
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch((e) => {
          this.formData.response = true
          this.formData.message = e.response.statusText
        })
    },
    close() {
      this.$emit('close')
    }
  },
  mounted() {
    this.loadNote()
  }
}
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 1111 !important;
  .modal {
    box-sizing: border-box;
    width: 911px;
    border: 1px solid #efefef;
    border-radius: 12px;
    background-color: #ffffff;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.07);
    overflow-x: auto;
    padding: 24px 40px 5px 40px;
    position: relative;
    .modal-header {
      border-bottom: 1px solid #e7e8e8;
      padding-bottom: 18px;
      h6 {
        color: $black;
        font-size: 21px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
        span {
          margin-top: 0.5rem;
          opacity: 0.46;
          color: #000000;
          font-family: Poppins;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 21px;
        }
      }
      .modal-btn-close {
        cursor: pointer;
      }
    }
    .modal-body {
      p {
        opacity: 0.7;
        color: rgba(0, 0, 0, 0.7);
        font-size: 15px;
        letter-spacing: 0;
        line-height: 21px;
        margin-top: 12px;
      }
    }
    .modal-footer {
      margin-top: 18px;
      align-items: center;
      display: block;
      .processed-msg {
        line-height: 20px;
        opacity: 0.46;
        b {
          font-weight: 600;
          color: red;
        }
      }
    }
    button {
      &.right {
        float: right;
      }
      &.disabled {
        pointer-events: none;
        opacity: 0.65;
      }
    }
  }
}
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin: 5px 0;
  .el-select-dropdown__item {
    padding: 8px 10px !important;
    color: #000000;
    height: 34px;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 400;
    font-family: Poppins;
  }
  .el-select-dropdown__item.selected {
    color: #424242;
    font-weight: 400;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.row {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 1rem;
  &.mt-0 {
    margin-top: 0;
  }
  textarea {
    width: 95%;
    padding: 0.5rem;
  }
  .characters {
    opacity: 0.46;
    color: #000000;
    font-family: Poppins;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 12px;
    text-align: right;
    float: left;
    width: 96%;
    padding: 0.5rem;
    padding-left: 0;
    border: 1px solid #c4c4c4;
  }
  .col {
    position: relative;
    width: 100%;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-1 {
    text-align: right;
    position: relative;
    width: 100%;
    flex: 0 0 8.8888%;
    max-width: 8.8888%;
    padding-right: 0.3rem;
  }
  .col-8 {
    position: relative;
    width: 100%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-4 {
    position: relative;
    width: 100%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  label {
    opacity: 0.7;
    color: #000000;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 20px;
    margin-right: 0.3rem;
  }
  input {
    width: 80%;
  }
}
.ck.ck-editor__main > .ck-editor__editable {
  min-height: 200px !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.quickaddlead-notes {
  margin-top: 1rem;
  .status-response {
    div {
      padding: 1rem;
      width: 50%;
      border-radius: 8px;
      margin-top: 0.5rem;
      align-items: center;
      display: flex;
      &.is-success {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
        img {
          margin-right: 0.5rem;
        }
      }
      &.is-error {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
        img {
          margin-right: 0.5rem;
        }
      }
    }
  }
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 100%;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.note-list {
  display: flex;
  flex-direction: column-reverse;
  max-height: 350px;
  overflow-y: auto;
  margin-bottom: 10px;
}
ul {
  margin-bottom: 10px;
  margin-right: 10px;
  li {
    display: flex;
    align-items: center;
    img {
      border-radius: 100%;
      margin-right: 10px;
      height: 36px;
      width: 36px;
    }
    .note-card {
      width: 100%;
      padding: 10px 0;
      border-bottom: 1px solid #e7e8e8;
      .note-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        div:first-child {
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 20px;
        }
        div:last-child {
          opacity: 0.46;
          font-size: 10px;
          letter-spacing: 0;
          line-height: 16px;
          text-align: right;
        }
      }
      .note-body {
        opacity: 0.7;
        font-size: 13px;
        letter-spacing: 0;
        line-height: 20px;
      }
      .note-files {
        padding-top: 5px;
        .note-file {
          margin-top: 2px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #e7e8e8;
          border-radius: 5px;
          &.p-1 {
            padding: 0.5rem;
          }
          img {
            height: 24px;
            width: 24px;
            opacity: 0.46;
            padding: 5px 5px;
            margin-right: 0;
          }
          span {
            margin-right: auto;
          }
        }
      }
      .assigned-lead {
        font-style: italic;
      }
      .app-updated{
        border: 1px solid #efefef;
        border-radius: 4px;
        padding: 10px 12px;
        margin-top: 5px;
        .value {
          display: contents !important;
        }
        .note-img {
          width: 20px;
          vertical-align:middle;
        }
      }
    }
  }
}
.notes {
  box-sizing: border-box;
  height: 72px;
  width: 100% !important;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 9px;
  &::placeholder {
    color: rgba(0, 0, 0, 0.46);
    font-size: 12px;
    letter-spacing: 0;
    line-height: 21px;
  }
}

.note-cta-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;
  //button {
  //  border: none;
  //  outline: none;
  //  background: none;
  //  padding: 0;
  //  &:hover {
  //    cursor: pointer;
  //  }
  //}
  .selected-files {
    display: flex;
    align-items: center;
    button {
      padding: 0.5rem;
      border-radius: 8px;
      &:hover {
        background: #eaeaea;
      }
    }
    span {
      margin-left: 0.5rem;
    }
  }
  .add-notes {
    height: 32px;
    width: 99px;
    border-radius: 8px;
    background-color: #266fe5;
    color: #00ffff;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    text-align: center;
    &:disabled {
      background-color: #eaeaea;
      color: rgba(0, 0, 0, 0.2);
    }
  }
}
.modal-alert.modal-alert_advice {
  border: 1px solid rgba(247, 127, 0, 0.3);
  background-color: rgba(247, 127, 0, 0.1);
}
.modal-alert {
  padding: 18px;
  color: black;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
  border-radius: 12px;
}
.text-center {
  text-align: center !important;
}
strong,
b {
  font-weight: bold !important;
}
.btn.bg-blue {
  border-radius: 8px;
}
</style>
